<template>
  <div id="contenedor-principal-consulta" class="container-fluid">
    <div v-show="mostrar">
      <!-- SECCION DE ENCABEZADOS -->
      <div id="encabezados">
          <h1>ALTA CRITERIOS PENALES</h1>
          <h4>Alta los criterios penales</h4>
          <div class="hr-titulo"></div>
      </div>
      <!-- SECCION DE CONSULTA -->
      <div id="seccion-consulta" class="row">
        <!-- SECCION INFORMATIVA -->
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-4 mt-3">
          <!-- SECCION FILTROS DE BUSQUEDA -->
          <form @submit="obtenerAmparosBD({evento:$event})" class="contenedor-color-negro row no-gutters pb-2">
            <!-- FILTRO NUMERO DE EXPEDIENTE -->
            <div id="filtros" class="form-group col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-0">
                <h6>Consecutivo</h6>
                <div class="input-group">
                    <div class="input-group-append">
                        <div class="input-group-text"><i class="fa fa-folder"></i></div>
                    </div>
                    <input class="form-control input-sm input-xs input-md input-lg py-2 border-left-0 border" type="text" v-model="numExpediente" v-mask="'####/####'" placeholder="####/####">
                </div>
            </div>
            <!-- ACCIONES -->
            <div id="seccion-acciones" class="justify-content-start">
              <button type="submit"  class="form-control btn btn-primary "><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
            </div>
          </form>
          <div class="container-fluid contenedor-color-negro contenedor-tabla-historico-CEDULAS-SINOJ">
            <table
                class="table table-striped table-light table-hover"
                :id="tablaAmparos.ID"              
                data-toggle="table"
                data-pagination="true"
                data-undefined-text="Sin información"
                data-maintain-selected="true"  
                data-page-size = "10"
                data-page-list="[5,10,20]"
                data-click-to-select="false"
                data-show-toggle="false"
                data-show-pagination-switch="true"
                data-search="true">
                <thead class="thead-dark">
                    <tr>
                        <th data-halign="center" data-width="5" data-align="center" data-field="DocumentoPadreID" data-sortable="true">
                            Folio
                        </th>
                        <th data-halign="center" data-width="5" data-align="center" data-field="AmparoExp" data-sortable="true">
                            Consecutivo
                        </th>
                        <th data-halign="center" data-width="5" data-align="center" data-field="TipoDeDocumento" data-sortable="true">
                            Tipo de Documento
                        </th>
                        <th data-halign="center" data-width="5" data-align="center" data-field="TocaOralExp" data-sortable="true">
                            Toca Oral
                        </th>
                        <th data-halign="center" data-width="10" data-align="center" data-field="Partes" data-sortable="true">
                            Partes
                        </th>
                        <th data-width="5" data-halign="center" data-align="center" data-field="accion" data-events="operateEvents">
                          Seleccion
                      </th>
                    </tr>
                </thead>
                <tbody></tbody>
            </table>
        </div>
        </div>
      </div>
      </div>
      <div v-show="mostrarresolucion">
        <ResolucionAmparo v-on:evtFinalizado="evtFinalizado" ref="agregarRes"></ResolucionAmparo>
      </div>
  </div>
  

</template>

<script>
  import Layout from '@/components/SICPE/Comun/Plantilla.vue';
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import PDFDocument from '@/../src/components/Comunes/PDFDocument'
  import CCatalogoGenerico from '@/../src/components/SICPE/Comun/CCatalogoGenerico'
  import ResolucionAmparo from '@/../src/components/SICPE/Administracion/ResolucionAmparo'
  import VueMask from 'v-mask'

Vue.use(VueMask);
  export default {
    data() {
      return {
        rValidacion: false,
        mostrar: true,
        mostrarresolucion:false,
        value1: true,
        value2: false,
        enumeraciones,
        tablaAmparos: {
                ID: 'Tabla-amparos',
                Amparos: []
            },
        numExpediente: ''
      }
    },
    components: {
      CCatalogoGenerico,
      ResolucionAmparo
    },
    computed:{
    },
    methods: {
        validarCriterioExistente: async function(DocumentoPadreID) { 
            let procesoSinError = false;
            let peticion = {};
            peticion.DocumentoPadreID = DocumentoPadreID;
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = "SICPE/Registro/ValidaCriterio"//api.SICPE.sistema.registro.consultaAmparos.ObtenerAmparos;
                const URL_API_SERVICIO = SERVIDOR + METODO_API_OBTENER;
                const HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false,false);
                comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(URL_API_SERVICIO, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, Validacion, Satisfactorio } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                    await Promise.resolve(this.inicializarTabla({ elementos: [] }));
                } 
                else {
                  this.rValidacion = Validacion;
                  comun.SeEstaCargandoInformacion(false);
                }
                    
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return procesoSinError;
        },
        evtFinalizado: function(valor){
          this.numExpediente = '';
          this.tablaAmparos.Amparos = [];
          $('#Tabla-amparos').bootstrapTable({ data: this.tablaAmparos.Amparos });
          $('#Tabla-amparos').bootstrapTable('load', this.tablaAmparos.Amparos);
          this.mostrar = true;
          this.mostrarresolucion =false;
        },
        /**
         * Funcion encargada de llamar a servicio REST para obtener las cedul
         * @param {Object} peticion [valor correspondiente al objeto POST del servicio REST]
         * @param {Boolean} conMensajeDeRespuesta [valor correspondiente a la validacion para mostrar mensaje en el sistema con la respuesta de la peticio del servicio REST]
         */
         obtenerAmparosBD: async function({evento,conMensajeDeRespuesta = true }) { 
          //this.$ref['agregarRes'].amparoDocumentopadreId = this.numExpediente;
            evento.preventDefault();
            let procesoSinError = false;
            let peticion = {};
            peticion.numExpediente = this.numExpediente;
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SICPE.sistema.registro.consultaAmparos.ObtenerAmparos;
                const URL_API_SERVICIO = SERVIDOR + METODO_API_OBTENER;
                const HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false,false);
                comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(URL_API_SERVICIO, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, Amparo, Satisfactorio } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                    await Promise.resolve(this.inicializarTabla({ elementos: [] }));
                } 
                else {
                    this.tablaAmparos.Amparos = Amparo.map(aDB => {
                      let amparoObj = { ...aDB };
                      amparoObj.accion = `<i
                        class="fa fa-edit setprops"
                        title="Agregar Resolucion"
                      />`;
                      return amparoObj;
                    });
                    $('#Tabla-amparos').bootstrapTable({ data: this.tablaAmparos.Amparos });
                    $('#Tabla-amparos').bootstrapTable('load', this.tablaAmparos.Amparos);
                    procesoSinError = true;
                    console.log(this.tablaAmparos.Amparos);
                }
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return procesoSinError;
        }
    },
    created() {
    },
    mounted(){
      window.operateEvents = {'click .setprops': async(e, value, row, index) => { 
        let validarboolean = await Promise.resolve(this.validarCriterioExistente(row.DocumentoPadreID));
        console.log("rValidacion::::",this.validarboolean);
            if(this.rValidacion){
                  this.mostrar = false;
                  this.mostrarresolucion = true;
                  this.$refs["agregarRes"].tablaResolucion.params.amparoDocumentopadreId = row.DocumentoPadreID;
                  this.$refs["agregarRes"].tablaResolucion.params.consecutivoTocaOral = row.TocaOralExp;
                  this.$refs["agregarRes"].tablaResolucion.params.consecutivoAmparo = row.AmparoExp;        
            }
            else
            {
              comun.mensajeDeAlerta("Ya existe un criterio asignado para este amparo", null, null);
            }
          }
        };
    }
  }
</script>

<style scoped>
  h2 {
    font-size: 18px;
    border-bottom: 2px solid #FFF;
    padding-bottom: 8px;
    margin-bottom: 12px;
  }
</style>


// WEBPACK FOOTER //
// src/components/SICPE/Administracion/Registro.vue